export default __webpack_public_path__ + "static/media/blog-image.d4bfcb2f.png";